// extracted by mini-css-extract-plugin
export default {"kanbanBoard":"KanbanBoard_kanbanBoard__E-Pyv","kanbanColumns":"KanbanBoard_kanbanColumns__S3i0v"};